module.exports = __webpack_public_path__ + "static/img/icon_ripe.af44ba9.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/index/icon_ripe.svg
// module id = 394
// module chunks = 12